export default "__VITE_ASSET__BDkhES9b__"